<template>
  <div class="provider-card">
    <div class="card">
      <router-link :to="{ name: 'ProviderDetail' , params: { serviceId, id:value.provider._id} }">
        <div class="card-header" :style="{'background-image': 'url(' + bannerUrl + ')'}">
          <img class="avatar" :src="logo" />
          <!-- {{value}} -->
        </div>
      </router-link>
      <div class="card-body">
        <h3 class="card-title">
          <router-link :to="{ name: 'ProviderDetail' , params: { serviceId, id:value.provider._id} }">
            {{value.provider.displayName || value.provider.email || '...'}}
            <div class="verified-tag" v-if="value.provider.showVerifiedIcon"></div>
          </router-link>
        </h3>
        <div class="brief">
          <div class="star">
            <i class="fas fa-star"></i>
            <!-- {{ (( value.provider.totalStar/value.provider.totalRate) || 0).toFixed(1) }}/5 -->
            {{ caculateRating(value.services[0]) }}/5
          </div>
          <div class="price">{{$t('card_provider.price')}} 
            <span v-if="minPrice > 0">
              {{$t('card_provider.from')}}:
              <span class="font-weight-bold"> {{ minPrice }}K </span>
            </span>
            <span v-else>
              {{$t('card_provider.negotiable')}}
            </span>
          </div>
          <div
            class="distance"
            v-if="value.meta && value.meta.distance"
          >{{(value.meta.distance/1000).toFixed(2)}} km</div>
        </div>
        <p class="card-text"></p>
        <div class="location">
          <div class="header">{{$t('card_provider.location')}}</div>
          <span class="value">{{expotLocation(value)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// require("@/public/verified.svg");
export default {
  name: "ProviderCard",
  data() {
    console.log(this.value);
    return {
      minPrice: 0
    };
  },
  props: {
    value: Object,
    serviceId: String
  },
  filters:{
        formatPriceVND(value) {
            if(!value)
            {
            return 0;
            }
            // { style: 'currency', currency: 'VND' }
            return new Intl.NumberFormat('de-DE').format(value);
        },
  },
  computed: {
    bannerUrl() {
      if (
        this.value &&
        this.value.provider &&
        this.value.provider.bannerPhotos &&
        this.value.provider.bannerPhotos.length
      ) {
        return this.value.provider.bannerPhotos[0].replace("small", "medium");
      }
      return "";
    },
    logo() {
      if (
        this.value &&
        this.value.provider &&
        this.value.provider.avatar &&
        this.value.provider.avatar.length
      ) {
        return this.value.provider.avatar;
      }
      return "/avatar-default.png";
    }
  },
  methods: {
    expotLocation(item) {
      console.log("items", item);
      if (item.provider && item.provider.states ) {
        return item.provider.states.toString();
      }
    },
    caculateRating(value) {

      let totalStar = value && value.totalStar ?  value.totalStar : 0;
      let totalRate = value && value.totalRate ?  value.totalRate : 0;

      if ( totalStar == 0 && totalRate == 0 || totalStar == 0 || totalRate == 0 ) {
        return Number(0);
      }

      let results = totalStar / totalRate;
      
      if (results % 1 != 0) {
        results = results.toFixed(1);
      }

      return Number(results);
    },

    findMinPriceInService(services){
        let minPriceTemp = Infinity;

        if(services && services.length > 0){ 
          
          services.forEach(service => {
              if(minPriceTemp > service.minPrice  && service.minPrice > 0){
                minPriceTemp = service.minPrice
              }
          })
          const result = ( minPriceTemp / 1000 );

          if ( parseFloat(result) <= 0) {
            minPriceTemp = Infinity;
          }

          return minPriceTemp === Infinity ? 0 : parseInt(result);
        }

        return 0;
    }
  },
  async mounted(){
     this.minPrice = this.findMinPriceInService(this.value.services);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.provider-card {
  position: relative;
  .card {
    border-color: #f3f3f3;
    .card-header {
      height: 26vw;
      max-height: 125px;
      // object-fit: cover;
      background: no-repeat center #d8d8d8;
      background-size: cover;

      border-top-left-radius: calc(0.9rem - 1px);
      border-top-right-radius: calc(0.9rem - 1px);
      position: relative;
      .avatar {
        width: 25%;
        // height: 20%;
        position: absolute;
        bottom: 6px;
        left: 6px;
        border: 1.5px solid white;
        border-radius: 25%;
      }
    }
    .card-body {
      padding: 10px;
      font-size: 0.9em;
      .star {
        .fas {
          color: #ffc107;
        }
      }
      .brief {
        display: flex;
        overflow: hidden;
        font-size: 0.8em;
        .price {
          padding-left: 20px;
          flex: 1;
        }
      }
      .verified-tag {
        background-color: red;
        width: 15px;
        height: 22px;
        display: inline-block;
        background: url("/verified.svg") center no-repeat;
        background-size: 13px;
      }
      .card-title {
        line-height: 1;
      }
      .card-title a {
        font-size: 0.6em;
        color: black;
        font-weight: bold;
      }
    }
    .location {
      .value {
        font-weight: bold;
      }
    }
  }
}
@media (max-width: 575.98px) {
  .provider-card {
    .card {
      .card-body {
        .card-title a {
          // color: black;
          // font-size: 0.7em;
          // font-weight: bold;
        }
      }
    }
  }
}
</style>
